import { server_address } from "./Config";

// The app is mounted under the /cyclone basename (see App.js), so a hard
// redirect has to carry it - react-router's history isn't reachable from here.
const LOGIN_PATH = "/cyclone/login";

export async function setTokens(access, refresh){
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);
}

export function clearSession(){
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");
}

// Clears this device locally right away and revokes its session on the server
// in the background - the user's other devices stay signed in. The returned
// promise is only there for callers that want to wait; navigating away without
// awaiting it is fine.
export function logout(){
    const refreshToken = localStorage.getItem("refreshToken");
    clearSession();
    if (!refreshToken) return Promise.resolve();
    return fetch(server_address+"api/users/log-out", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({refreshToken})
    }).catch(() => {
        // The local session is gone either way; the server-side entry expires
        // on its own within the week.
    });
}

export function redirectToLogin(){
    clearSession();
    if (window.location.pathname !== LOGIN_PATH) {
        window.location.replace(LOGIN_PATH);
    }
}

// Whichever call triggers the refresh first wins; the others await the same
// request instead of firing their own. Concurrent refreshes used to leave the
// stored token out of sync with the server's.
let pendingRefresh = null;

/**
 * @returns {Promise<'ok'|'expired'|'error'>} 'expired' means the session is
 * over and the caller should send the user to the login screen.
 */
export function RefreshToken(){
    if (!pendingRefresh) {
        pendingRefresh = runRefresh().finally(() => { pendingRefresh = null; });
    }
    return pendingRefresh;
}

async function runRefresh(){
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return 'expired';

    let rawResponse;
    let content;
    try {
        rawResponse = await fetch(server_address+"api/users/refresh-token", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({token: refreshToken})
        });
        content = await rawResponse.json();
    } catch (error) {
        // Network hiccup - the session may still be perfectly valid.
        return 'error';
    }

    if (rawResponse.status === 200 && content && content.accessToken) {
        setTokens(content.accessToken, content.refreshToken || refreshToken);
        return 'ok';
    }
    if (rawResponse.status === 401 || rawResponse.status === 403) {
        return 'expired';
    }
    return 'error';
}
